import { QueovalBase } from '../global/class.global';
import { MissionEC } from './mission';

export class ReconduiteModel extends QueovalBase {
  public ListTypeResponsable: Array<TypeResponsable>;
  public ListCollaborateur: Array<Collaborateur>;
  public ListMission: Array<MissionEC>;
  public MissionSelected: MissionEC;
  public intFactPrep: number;
  public idDocument: string;
 // public StrSymboleMonnaie: string;
}

export class TypeResponsable {
  public id: string;
  public value: string;
}
export class Collaborateur {
  public id: string;
  public value: string;
}
